import { render, staticRenderFns } from "./DateBlock.vue?vue&type=template&id=95cad2e8&"
import script from "./DateBlock.vue?vue&type=script&lang=js&"
export * from "./DateBlock.vue?vue&type=script&lang=js&"
import style0 from "./DateBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DateBlock.vue"
export default component.exports